/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-22 13:12:16
 * @LastEditors: 陈钊贤
 * @Description: 接口文档
 * @LastEditTime: 2021-08-13 10:42:50
 */
import { request } from "./api-require";
const API_URL = "/basic-system/v1";
//登录
export const sysLogin = (data = {}, config = {}) => {
    return request(API_URL + "/auth/login", data, config);
};
//退出登录
export const sysLoginOut = (data = {}, config = {}) => {
    return request(API_URL + "/auth/logout", data, config);
};
//获取字典大类信息列表
export const getDictTypeList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/dict/type/list", data, config);
};
//获取字典大类信息列表---分页
export const getDictTypeListPage = (data = {}, config = {}) => {
    return request(API_URL + "/dict/type/page", data, config);
};
//新增字典大类
export const addDictType = (data = {}, config = {}) => {
    return request(API_URL + "/dict/type/add", data, config);
};
//修改字典大类
export const upDictType = (data = {}, config = {}) => {
    return request(API_URL + "/dict/type/upd", data, config);
};
//删除字典大类
export const delDictType = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/dict/item/delete", data, config);
};
//根据字典小类pkid的操作排序
export const sortDictType = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/dict/item/sort", data, config);
};
//获取字典信息指定大类下小类列表
export const getDictItemAll = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/dict/item/list", data, config);
};
//分页获取字典信息指定大类下小类列表
export const getDictItemList = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/dict/item/page", data, config);
};
//批量获取多个字典信息大类下小类列表集合
export const getDictItemAllList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/dict/item/list_batch", data, config);
};
//修改字典小类
export const upDictItem = (data = {}, config = {}) => {
    return request(API_URL + "/dict/item/upd", data, config);
};
//新增字典小类
export const addDictItem = (data = {}, config = {}) => {
    return request(API_URL + "/dict/item/add", data, config);
};
//删除字典小类
export const delDictItem = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/dict/item/del", data, config);
};
//查看运营商列表
export const getOperList = (data = {}, config = {}) => {
    return request(API_URL + "/sys/opr/page", data, config);
};
//查看所有运营商列表
export const getAllOperList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/opr/list", data, config);
};
//运营商详情
export const getOperDetails = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/opr/get", data, config);
};
//修改运营商
export const upDataOper = (data = {}, config = {}) => {
    return request(API_URL + "/sys/opr/upd", data, config);
};
//删除运营商
export const delOper = (data = {}, config = {}) => {
    config.method = "del";
    return request(API_URL + "/sys/opr/del", data, config);
};
//新增运营商
export const addOper = (data = {}, config = {}) => {
    return request(API_URL + "/sys/opr/add", data, config);
};
//新增运营商短信配置
export const addOperMsgConfig = (data = {}, config = {}) => {
    return request(API_URL + "/sys/opr/add_opr_sms_config", data, config);
};
//修改运营商短信配置
export const updataOperMsgConfig = (data = {}, config = {}) => {
    return request(API_URL + "/sys/opr/upd_opr_sms_config", data, config);
};
//修改运营商移动端配置
export const updataOperAppConfig = (data = {}, config = {}) => {
    return request(API_URL + "/sys/opr/upd_app_config", data, config);
};
//获取运营商移动端配置
export const getOprAppConfig = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/opr/app/config", data, config);
};
//绑定充电桩
export const bindOperPile = (data = {}, config = {}) => {
    return request(API_URL + "/sys/opr/bind", data, config);
};
//解定充电桩
export const unbindOperPile = (data = {}, config = {}) => {
    return request(API_URL + "/sys/opr/unbind", data, config);
};
//分页获取运营商已关联的充电桩
export const getBindOperPile = (data = {}, config = {}) => {
    return request(API_URL + "/sys/opr/bound/pile/page", data, config);
};
//分页获取运营商未关联的充电桩
export const getUnbindOperPile = (data = {}, config = {}) => {
    return request(API_URL + "/sys/opr/unbound/pile/page", data, config);
};
//用户
//查询所有运营商自定义角色列表
export const getAllRole = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/role/all", data, config);
};
//分页查询运营商自定义角色列表
export const getRoleList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/role/page", data, config);
};
//保存角色
export const saveRole = (data = {}, config = {}) => {
    return request(API_URL + "/role/save", data, config);
};
//删除角色
export const delRole = (data = {}, config = {}) => {
    return request(API_URL + "/role/delete", data, config);
};
//保存接口权限
export const saveInterfacePermission = (data = {}, config = {}) => {
    return request(API_URL + "/role/save_interface_permission", data, config);
};
//菜单权限列表
export const getPermission = (data = {}, config = {}) => {
    return request(API_URL + "/role/permission", data, config);
};
//查询菜单接口权限列表
export const getInterfacePermission = (data = {}, config = {}) => {
    return request(API_URL + "/role/query_interface_permission", data, config);
};
//获取角色功能菜单权限
export const getrRolePermission = (data = {}, config = {}) => {
    return request(API_URL + "/user/role_permission", data, config);
};
//根据不同用户角色类型 及 所属系统 查询角色列表
export const getRoleSelect = (data = {}, config = {}) => {
    return request(API_URL + "/role/select", data, config);
};
//根据userid 获取角色
export const getUserRole = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/role/select", data, config);
};
//获取角色详情
export const getRoleDetails = (data = {}, config = {}) => {
    return request(API_URL + "/role/selectOne", data, config);
};
//保存角色权限
export const setPermission = (data = {}, config = {}) => {
    return request(API_URL + "/role/set_permission", data, config);
};
//查询设备型号列表
export const getModelList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/device/model/opr/list", data, config);
};
//查询设备型号列表---新增时候
export const getModelListAdd = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/device/model/list", data, config);
};
// 分页获取设备型号列表
export const getModelListPage = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/model/page", data, config);
};
// 新增设备型号
export const addModelNew = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/model/add", data, config);
};
// 新增选配信息
export const addMatching = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/model/add/matching", data, config);
};
// 删除选配信息
export const deleteMatching = (data = {}, config = {}) => {
    config.method = "getDel";
    // config.method = "del";s
    return request(API_URL + "/sys/device/model/delete/matching", data, config);
};
// 删除设备型号
export const delOneModel = (data = {}, config = {}) => {
    config.method = "del";
    return request(API_URL + "/sys/device/model/del_batch", data, config);
};
// 修改设备型号
export const updModelNew = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/model/upd", data, config);
};
//获取用户列表
export const getUserList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/user/page", data, config);
};
//修改用户
export const upDataUser = (data = {}, config = {}) => {
    return request(API_URL + "/sys/user/upd", data, config);
};
//新增用户
export const addUser = (data = {}, config = {}) => {
    return request(API_URL + "/sys/user/add", data, config);
};
//删除用户
export const deleteUser = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/sys/user/del", data, config);
};
//查看用户
export const getUserDetails = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/user/detail", data, config);
};
//在线用户
export const getOnlineuser = (data = {}, config = {}) => {
    return request(API_URL + "/online_user/page", data, config);
};
//强制下线
export const outUser = (data = {}, config = {}) => {
    return request(API_URL + "/online_user/offline", data, config);
};
//获取设备列表
export const getDeviceList = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device_manage/page", data, config);
};
//获取设备统计
export const getDeviceInitData = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/device_manage/stat", data, config);
};
// 获取设备版本号
export const getUpgradePack = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device_manage/upgrade_packs/list", data, config);
};
// 升级设备
export const upgradeDevice = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/device_manage/upgrade_device", data, config);
};
// 设备详情
export const queryTableDataDetail = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device_manage/detail", data, config);
};
// // 设备调试
// export const getDeviceGun = (data = {}, config: objAny = {}): Promise<objAny> => {
//   return request(API_URL + "/sys_device_manage/getDeviceGun", data, config);
// };
//获取设备统计
export const getDeviceGun = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/device_manage/device_guns/list", data, config);
};
// 开始设备调试
export const deviceDoDebug = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device_manage/debug", data, config);
};
// 设备调试结果
export const getDebugResult = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device_manage/debug_results/list", data, config);
};
// 分页获取设备清单
export const getDevicePageList = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/page", data, config);
};
// 获取设备统计
export const getDeviceCout = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/get_cout", data, config);
};
//批量删除设备
export const delBatch = (data = {}, config = {}) => {
    config.method = "del";
    return request(API_URL + "/sys/device/del_batch", data, config);
};
//批量设备绑定运营商
export const bindOperBatch = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/bind_oper_batch", data, config);
};
//批量设备解绑运营商
export const unbindOperBatch = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/unbind_oper_batch", data, config);
};
//根据运营商获取充电站
export const getStation = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/alarm/getStationByOpr", data, config);
};
//批量设备修改型号
export const upDevModel = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/upd_model_batch", data, config);
};
// 设备型号批量添加设备
export const pilesAddBatch = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/manage/add_batch", data, config);
};
// 获取设备型号标配或选配参数列表
export const getModelOptionsList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/device/model/options/list", data, config);
};
// 获取设备型号详情
export const deviceModelDetail = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/device/model/detail", data, config);
};
//获取省市区
export const getFindAreaList = (data = {}, config = {}) => {
    return request(API_URL + "/region/findAreaList", data, config);
};
//上传图片
export const uploadImage = (data = {}, config = {}) => {
    return request(API_URL + "/file/upload_image", data, config);
};
//上传文件
export const uploadFile = (data = {}, config = {}) => {
    return request(API_URL + "/file/upload", data, config);
};
//下载文件
export const downloadFile = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/file/download", data, config);
};
// 获取警告查询
export const getAlarmQuery = (data = {}, config = {}) => {
    return request(API_URL + "/alarm/query", data, config);
};
// 获取运营商
export const getSearchInitData = (data = {}, config = {}) => {
    return request(API_URL + "/alarm/searchInitData", data, config);
};
// 通过运营商获取充电桩
export const getStationByOpr = (data = {}, config = {}) => {
    return request(API_URL + "/alarm/getStationByOpr", data, config);
};
// 获取设备告警逐条设置
export const getAlarmSettingPage = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/alarm_rule/get_alarm_setting_page", data, config);
};
//设备告警逐条设置等级修改存储
export const alarmSaveSingle = (data = {}, config = {}) => {
    return request(API_URL + "/alarm_rule/save_single", data, config);
};
// 设备告警逐条设置等级删除  /alarm_rule/delete?rulePkId=1255667266142404610
export const alarmSingleDel = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/alarm_rule/delete", data, config);
};
// 获取设备告警批量设置
export const getBatchSetting = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/alarm_rule/get_batch_setting", data, config);
};
// 获取警告详情
export const getAlarmOrderDetail = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/alarm/queryOrderDetail", data, config);
};
// /alarm/count
export const alarmCount = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/alarm/summary", data, config);
};
//告警概要总值
export const alarmSummary = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/alarm/summary", data, config);
};
//告警概要trend
export const alarmTrend = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/alarm/trend", data, config);
};
//告警概要充电站top5
export const alarmStationTop5 = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/alarm/station/top5", data, config);
};
//告警概要设备top5
export const alarmChargeTop5 = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/alarm/charge/top5", data, config);
};
// 获取告警等级  /dict/item/list?typeId=166
export const getDictList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/dict/item/list", data, config);
};
// 获取流量阀值--通过告警等级
export const getSimAlarm = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/alarm_rule/get_sim_alarm", data, config);
};
// 确定流量阀值
export const saveSimAlarm = (data = {}, config = {}) => {
    return request(API_URL + "/alarm_rule/save_sim_alarm", data, config);
};
// 获取设备告警批量设置
export const getFaultCode = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/alarm_rule/get_fault_code", data, config);
};
// 设备告警批量设置详情提交
export const saveBatchSetting = (data = {}, config = {}) => {
    return request(API_URL + "/alarm_rule/save_batch", data, config);
};
//设备厂商下拉接口
export const getManufacturerList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/device/manufacturer/get", data, config);
};
//查询子系统信息不分页
export const getSystemAll = (data = {}, config = {}) => {
    return request(API_URL + "/subsystem/sub_system_all", data, config);
};
//根据子系统获取所有的菜单
export const getSystemList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/module/sub_system_list", data, config);
};
//新增模块菜单
export const addSystem = (data = {}, config = {}) => {
    return request(API_URL + "/module/add", data, config);
};
//修改模块菜单
export const upSystem = (data = {}, config = {}) => {
    return request(API_URL + "/module/upd", data, config);
};
//删除模块菜单
export const delSystem = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/module/del", data, config);
};
//新增权限
export const addPrivilege = (data = {}, config = {}) => {
    return request(API_URL + "/module/add_privilege", data, config);
};
//删除权限
export const delPrivilege = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/module/del_privilege", data, config);
};
//设备厂商--分页获取
export const getManufacturerPage = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/manufacturer/page", data, config);
};
//设备厂商--新增
export const addManufacturer = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/manufacturer/add", data, config);
};
//设备厂商--修改
export const updManufacturer = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/manufacturer/upd", data, config);
};
//设备厂商--删除
export const delManufacturer = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/sys/device/manufacturer/del", data, config);
};
//系统更新日志
export const getSystemUpdate = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/system_update/page", data, config);
};
//新增或修改系统更新日志
export const addUpSystemUpgrade = (data = {}, config = {}) => {
    return request(API_URL + "/system_update/add_update/system_upgrade", data, config);
};
//删除系统更新日志
export const delSystemUpgrade = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/system_update/delete/system_upgrade", data, config);
};
//下发费率--下发电价
export const sendSyncfeeRatecmd = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/sys/device/opr/send_syncfee_ratecmd", data, config);
};
//解锁,下发二维码
export const sendPileOperation = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/sys/device/opr/send_pile_operation", data, config);
};
// 分页查询项目
export const getProjectPage = (data = {}, config = {}) => {
    return request(API_URL + "/project/page", data, config);
};
//新增项目
export const getProjectAdd = (data = {}, config = {}) => {
    return request(API_URL + "/project/add", data, config);
};
// 删除项目
export const getProjectDelete = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/project/delete", data, config);
};
// licence分页
export const projectLicencePage = (data = {}, config = {}) => {
    return request(API_URL + "/project/license/page", data, config);
};
// 添加licence
export const projectLicenceAdd = (data = {}, config = {}) => {
    return request(API_URL + "/project/license/add", data, config);
};
// 添加licence
export const projectLicenceUpd = (data = {}, config = {}) => {
    return request(API_URL + "/project/license/update", data, config);
};
// 删除licence
export const projectLicenceDelete = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/project/license/delete", data, config);
};
// 下载附件
export const projectLicenceDownload = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/project/license/download", data, config);
};
// 重置密码
export const resetpwd = (data = {}, config = {}) => {
    return request(API_URL + "/sys/user/resetpwd/default", data, config);
};
// 获取运营商的登录地址
export const getLoginUrl = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/opr/get_login_url", data, config);
};
// 获取获取License模块集合
export const getLicenceModual = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/project/license/get/license_module", data, config);
};
// 获取模板文件
export const getLModelFile = (data = {}, config = {}) => {
    return request(API_URL + "/template/page", data, config);
};
// 新增模板文件--修改
export const getLModelFileAdd = (data = {}, config = {}) => {
    return request(API_URL + "/template/save", data, config);
};
// 删除模板文件
export const getLModelFileDel = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/template/delete", data, config);
};
// 获取模板文件详情
export const getLModelFileDetail = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/template/detail", data, config);
};
// 获取设备采集扩展属性列表
export const getExpandPropertyList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/device/manage/expand/property/list", data, config);
};
// 获取停止原因
export const getStopReasonPage = (data = {}, config = {}) => {
    return request(API_URL + "/sys/stop/reason/page", data, config);
};
// 停止原因--修改
export const updataStopReason = (data = {}, config = {}) => {
    return request(API_URL + "/sys/stop/reason/update", data, config);
};
// 停止原因--新增
export const addStopReason = (data = {}, config = {}) => {
    return request(API_URL + "/sys/stop/reason/save", data, config);
};
// 批量更新停止原因的责任类型
export const allUpdateStopReason = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/sys/stop/reason/update/responsibility_type/to_stop_code", data, config);
};
// 删除停止原因
export const getStopReasonDel = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/sys/stop/reason/delete", data, config);
};
// 获取停止原因详情
export const getStopReasonDetail = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/stop/reason/detail", data, config);
};
// 获取告警配置
export const getAlarmSetPage = (data = {}, config = {}) => {
    return request(API_URL + "/sys/fault/code/lib/page", data, config);
};
// 新增告警配置--修改
export const getAlarmSetAdd = (data = {}, config = {}) => {
    return request(API_URL + "/sys/fault/code/lib/save", data, config);
};
// 删除告警配置
export const getAlarmSetDel = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/sys/fault/code/lib/delete", data, config);
};
// 获取告警配置详情
export const getAlarmSetDetail = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/fault/code/lib/detail", data, config);
};
// 获取运营商统计数据
export const getOperStatistics = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/opr/statistics", data, config);
};
// 更新运营商充电桩枪口二维码链接
export const updateOprQRCode = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/opr/upd_qr_type", data, config);
};
// 更新充电桩故障代码库
export const updateFaultCode = (data = {}, config = {}) => {
    return request(API_URL + "/sys/fault/code/lib/update", data, config);
};
// 批量新增充电桩故障代码库
export const addFaultCode = (data = {}, config = {}) => {
    return request(API_URL + "/sys/fault/code/lib/save_batch", data, config);
};
// 批量更新故障代码告警等级
export const updataLevelToFaultCode = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/sys/fault/code/lib/update/alarm/level/to_fault_code", data, config);
};
// 批量更新故障代码告警类型
export const updatTypeToFaultCode = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/sys/fault/code/lib/update/alarm/type/to_fault_code", data, config);
};
// 生产任务单 -- 列表
export const getProductionPage = (data = {}, config = {}) => {
    return request(API_URL + "/sys/production/page", data, config);
};
// 生产任务单 -- 新增
export const addProduction = (data = {}, config = {}) => {
    return request(API_URL + "/sys/production/add", data, config);
};
// 生产任务单 -- 修改状态
export const updataProduction = (data = {}, config = {}) => {
    return request(API_URL + "/sys/production/upd_status", data, config);
};
// 生产任务单 -- 批量删除
export const delProduction = (data = {}, config = {}) => {
    config.method = "del";
    return request(API_URL + "/sys/production/del_batch", data, config);
};
// 生产任务单 -- 详情
export const getProductionDetails = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/production/detail", data, config);
};
// 生产任务单 -- 作废
export const invalidProduction = (data = {}, config = {}) => {
    return request(API_URL + "/sys/production/invalid", data, config);
};
// 生产任务单 -- 发货
export const deliveryProduction = (data = {}, config = {}) => {
    return request(API_URL + "/sys/production/upd_delivery", data, config);
};
// 生产任务单 -- 品质检验
export const inspectionProduction = (data = {}, config = {}) => {
    return request(API_URL + "/sys/production/upd_inspection", data, config);
};
// 生产任务单 -- 修改生产任务单优先级
export const updPriorityProduction = (data = {}, config = {}) => {
    return request(API_URL + "/sys/production/upd_priority", data, config);
};
// 生产任务单 -- 生产任务单开始生产
export const updStartProductionProduction = (data = {}, config = {}) => {
    return request(API_URL + "/sys/production/upd_start_production", data, config);
};
// 生产任务单 -- 设备入库
export const updStorageProduction = (data = {}, config = {}) => {
    return request(API_URL + "/sys/production/upd_storage", data, config);
};
// 销售订单 -- 列表
export const getSalesOrdersList = (data = {}, config = {}) => {
    return request(API_URL + "/sys/sales/Orders/page", data, config);
};
// 销售订单 -- 新增
export const addSalesOrders = (data = {}, config = {}) => {
    return request(API_URL + "/sys/sales/Orders/add", data, config);
};
// 销售订单 -- 修改
export const updSalesOrders = (data = {}, config = {}) => {
    return request(API_URL + "/sys/sales/Orders/upd", data, config);
};
// 销售订单 -- 删除
export const delSalesOrders = (data = {}, config = {}) => {
    config.method = "del";
    return request(API_URL + "/sys/sales/Orders/del_batch", data, config);
};
// 销售订单 -- 详情
export const getSalesOrdersDetail = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/sales/Orders/detail", data, config);
};
// 销售订单 -- 修改优先级
export const updPrioritySalesOrders = (data = {}, config = {}) => {
    return request(API_URL + "/sys/sales/Orders/upd_priority", data, config);
};
// 销售订单 -- 设备发货
export const whetherShipmentsSalesOrders = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/sys/sales/Orders/whether_shipments", data, config);
};
// 后台SIM卡召测
export const backstageCalledSim = (data = {}, config = {}) => {
    // config.method = "postStr";
    return request(API_URL + "/sys/sim/backstage/called_sim", data, config);
};
// 根据召测到的记录保存到管理页面
export const backstageCalledSimSaveDetails = (data = {}, config = {}) => {
    return request(API_URL + "/sys/sim/backstage/called_sim/save_details", data, config);
};
// 根据召测到的记录保存并导出
export const backstageCalledSimSaveExport = (data = {}, config = {}) => {
    return request(API_URL + "/sys/sim/backstage/called_sim/save_export", data, config);
};
// SIM卡申领页面导入信息
export const backstageSimExport = (data = {}, config = {}) => {
    return request(API_URL + "/sys/sim/backstage/import", data, config);
};
// 新增sim卡申领
export const addBackstageSimReceive = (data = {}, config = {}) => {
    return request(API_URL + "/sys/sim/backstage/receive", data, config);
};
// 分页查询后台SIM卡列表
export const getBackstageSimList = (data = {}, config = {}) => {
    return request(API_URL + "/sys/sim/backstage/page", data, config);
};
// 下载模板
export const downloadTmp = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/template/select", data, config);
};
// SIM卡申领页面导入信息
export const importSimBackstage = (data = {}, config = {}) => {
    return request(API_URL + "/sys/notice/page", data, config);
};
// 分页获取通知管理列表
export const getNoticeList = (data = {}, config = {}) => {
    return request(API_URL + "/sys/notice/page", data, config);
};
// 获取通知管理详情
export const getNoticeDetails = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/notice/get", data, config);
};
// 新增通知管理
export const addNotice = (data = {}, config = {}) => {
    return request(API_URL + "/sys/notice/add", data, config);
};
// 修改通知管理
export const updateNotice = (data = {}, config = {}) => {
    return request(API_URL + "/sys/notice/update", data, config);
};
// 删除通知管理
export const deleteNotice = (data = {}, config = {}) => {
    return request(API_URL + "/sys/notice/delete", data, config);
};
// 发布通知管理
export const publishNotice = (data = {}, config = {}) => {
    return request(API_URL + "/sys/notice/publish", data, config);
};
// 导入设备数据
export const importDevice = (data = {}, config = {}) => {
    config.method = "formData";
    return request(API_URL + "/sys/device/manage/import", data, config);
};
// 批量添加导入设设备
export const addBatchImportDevice = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/manage/import/add_batch", data, config);
};
// 下载设备清单导入模板
export const downTemplate = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/device/manage/down/template", data, config);
};
// 分页查询设备报告档案
export const getDeviceArchivePage = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/archive/page", data, config);
};
// 添加设备报告档案
export const addDeviceArchive = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/archive/add", data, config);
};
// 删除设备报告档案
export const delDeviceArchive = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/archive/delete", data, config);
};
// 更换设备报告档案
export const upDeviceArchive = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/archive/update/attachment", data, config);
};
// 设备型号-下拉框
export const getDeviceArchive = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/sys/device/archive/model", data, config);
};
// 获取idemToken的接口
export const getAuthIdempotence = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/auth/idempotence", data, config);
};
// 获取公众号/小程序授权链接
export const getWechatAutoUrl = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/wechat/deploy/auth/link", data, config);
};
// 获取公众号/小程序授权刷新
export const getWechatAutoRefresh = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/wechat/deploy/auth/refresh", data, config);
};
// 分页获取公众号/小程序
export const getWechatList = (data = {}, config = {}) => {
    return request(API_URL + "/wechat/deploy/app/page", data, config);
};
// 小程序 - 获取所有已发布版本号
export const getWechatReleasedVersionList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/wechat/deploy/released/version/list", data, config);
};
// 新增公众号/小程序
export const addWechatList = (data = {}, config = {}) => {
    return request(API_URL + "/wechat/deploy/app/add", data, config);
};
// 修改公众号/小程序
export const updWechatList = (data = {}, config = {}) => {
    return request(API_URL + "/wechat/deploy/app/upd", data, config);
};
// 删除公众号/小程序
export const delWechatList = (data = {}, config = {}) => {
    return request(API_URL + "/wechat/deploy/app/del", data, config);
};
// 统计公众号/小程序发布状态
export const getWechatStat = (data = {}, config = {}) => {
    return request(API_URL + "/wechat/deploy/app/stat", data, config);
};
// 统计公众号/小程序发布状态
export const getWechatAudit = (data = {}, config = {}) => {
    return request(API_URL + "/wechat/deploy/template/audit/query", data, config);
};
// 小程序 - 获取草稿箱代码列表
export const getWechatDeployRaftList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/wechat/deploy/raft/list", data, config);
};
// 小程序 - 提交草稿箱代码至模板
export const addWechatDeployTemplate = (data = {}, config = {}) => {
    return request(API_URL + "/wechat/deploy/template/add", data, config);
};
// 小程序 - 删除代码模板
export const delWechatTemplate = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/wechat/deploy/template/del", data, config);
};
// 小程序 - 获取模板代码列表
export const getWechatDeployTemplateList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/wechat/deploy/template/list", data, config);
};
// 小程序 - 上传代码并生成体验版
export const commitWechatDeployTemplate = (data = {}, config = {}) => {
    return request(API_URL + "/wechat/deploy/template/commit", data, config);
};
// 小程序 - 提交代码审核
export const submitWechatDeployTemplate = (data = {}, config = {}) => {
    return request(API_URL + "/wechat/deploy/template/submit", data, config);
};
// 小程序 - 发布已通过审核的小程序
export const releaseWechat = (data = {}, config = {}) => {
    return request(API_URL + "/wechat/deploy/template/release", data, config);
};
// 小程序 - 小程序版本回退
export const versionRollbackWechat = (data = {}, config = {}) => {
    return request(API_URL + "/wechat/deploy/version/rollback", data, config);
};
// 小程序 - 配置小程序用户隐私保护指引
export const settingWechatPrivacy = (data = {}, config = {}) => {
    return request(API_URL + "/wechat/deploy/privacy/setting", data, config);
};
// 小程序 - 根据APPID获取隐私信息
export const getWechatDeployPrivacy = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/wechat/deploy/privacy/get", data, config);
};
// 小程序 - 根据APPID获取域名信息
export const getWechatDeployDomain = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/wechat/deploy/domain/get", data, config);
};
// 小程序 - 第三方平台设置域名信息
export const setWechatDeployDomain = (data = {}, config = {}) => {
    return request(API_URL + "/wechat/deploy/domain/set", data, config);
};
// 小程序 - 重置API调用次数
export const clearWechatDeployQuota = (data = {}, config = {}) => {
    return request(API_URL + "/wechat/deploy/clear/quota", data, config);
};
// 小程序 - 手动刷新体验二维码
export const getWechatQrcodeRefresh = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/wechat/deploy/taste/qrcode/refresh", data, config);
};
// 小程序 - 获取小程序可回退版本
export const getWechatDeployVersionRollback = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/wechat/deploy/version/rollback/list", data, config);
};
// 分页获取日志记录
export const getArOperationLogPage = (data = {}, config = {}) => {
    return request(API_URL + "/ar/operation/log/page", data, config);
};
// 分页查询地区列表
export const getRegionFindAreaList = (data = {}, config = {}) => {
    return request(API_URL + "/region/page/findAreaList", data, config);
};
// 更新省市行政区信息
export const updateRegionInfo = (data = {}, config = {}) => {
    return request(API_URL + "/region/update/region_info", data, config);
};
// 删除省市行政区信息
export const delRegionInfo = (data = {}, config = {}) => {
    return request(API_URL + "/region/del/region_info", data, config);
};
// 查询模板文件信息
export const SIMTemplateSelect = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/template/select", data, config);
};
// 获取微信服务商配置
export const getWechatServiceProvider = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/wechat/service/provider/get", data, config);
};
// 修改微信服务商配置
export const updWechatServiceProvider = (data = {}, config = {}) => {
    return request(API_URL + "/wechat/service/provider/upd", data, config);
};
// 新增微信服务商配置
export const addWechatServiceProvider = (data = {}, config = {}) => {
    return request(API_URL + "/wechat/service/provider/add", data, config);
};
// 审核运营商
export const auditOpr = (data = {}, config = {}) => {
    return request(API_URL + "/sys/opr/audit", data, config);
};
// 查询营商注册发送短信配置
export const getRegisterSmsConfig = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/info/register/sms/config/get", data, config);
};
// 保存营商注册发送短信配置
export const saveRegisterSmsConfig = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/opr/info/register/sms/config", data, config);
};
// 分页获取sim卡概况信息
export const getOprSimSummary = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sim/summary/page", data, config);
};
// 获取sim卡概况统计信息
export const getOprSimSummarysStatistics = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sim/summary/statistics", data, config);
};
// 分页获取sim卡信息
export const getOprSim = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sim/page", data, config);
};
// 获取sim卡统计数据
export const getOprSimStatistics = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sim/statistics", data, config);
};
// 召测sim卡
export const recallOprSim = (data = {}, config = {}) => {
    return request(API_URL + "/opr/sim/recall", data, config);
};
// 变更sim卡状态
export const changeOprSim = (data = {}, config = {}) => {
    return request(API_URL + "/opr/sim/change", data, config);
};
// 续费sim卡
export const renewalOprSim = (data = {}, config = {}) => {
    return request(API_URL + "/opr/sim/renewal", data, config);
};
// 备注sim卡
export const remarkOprSim = (data = {}, config = {}) => {
    return request(API_URL + "/opr/sim/remark", data, config);
};
// 获取变更记录
export const getOprSimChangeTrailPage = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sim/change/trail/page", data, config);
};
// 获取续费记录
export const getOprSimRenewalTrailPage = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sim/renewal/trail/page", data, config);
};
// 导入sim卡
export const importSim = (data = {}, config = {}) => {
    config.method = "formData";
    return request(API_URL + "/opr/sim/import", data, config);
};
// 变更运营商运营状态
export const changeOprStatus = (data = {}, config = {}) => {
    return request(API_URL + "/sys/opr/os/change", data, config);
};
// 更新运营商系统服务配置
export const updOprServiceConfig = (data = {}, config = {}) => {
    return request(API_URL + "/sys/opr/service/config/upd", data, config);
};
